// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-97082e8e]{position:relative;top:-70px}[data-v-97082e8e] .el-dialog__footer,[data-v-97082e8e] .el-dialog__header{border:none;padding:0}", ""]);
// Exports
module.exports = exports;
